import React from "react";

export const Footer = () => (
  <footer className="py-12 px-4 lg:px-8 gradient-bg-purple-grey">
    <div className="container mx-auto max-w-7xl">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2 md:col-span-1">
          <h3 className="text-2xl font-bold mb-4 gradient-text-purple">
            SnapLading
          </h3>
          <p className="text-sm text-white">
            AI agent bill of lading processing for modern logistics.
          </p>
        </div>
        <div>
          <h4 className="font-semibold mb-3 text-white">Product</h4>
          <ul className="space-y-2 text-sm text-white">
            <li>
              <a
                href="/docs"
                className="text-white hover:text-purple-400 transition-colors"
              >
                Documentation
              </a>
            </li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold mb-3 text-white">Company</h4>
          <ul className="space-y-2 text-sm text-white">
            <li>
              <a
                href="/careers"
                className="text-white hover:text-purple-400 transition-colors"
              >
                Careers
              </a>
            </li>
            <li>
              <a
                href="/contact"
                className="text-white hover:text-purple-400 transition-colors"
              >
                Contact
              </a>
            </li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold mb-3 text-white">Legal</h4>
          <ul className="space-y-2 text-sm text-white">
            <li>
              <a
                href="/privacy"
                className="text-white hover:text-purple-400 transition-colors"
              >
                Privacy
              </a>
            </li>
            <li>
              <a
                href="/terms"
                className="text-white hover:text-purple-400 transition-colors"
              >
                Terms
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="mt-8 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
        <p className="text-sm text-white">
          © {new Date().getFullYear()} Open Verify Inc. All rights reserved.
        </p>
      </div>
    </div>
  </footer>
);
